/**
 * Given an array of report posts and an array of active filters,
 * return a filtered list of report posts that satisfy the active filters.
 * @param {Array} research - An array of report posts to filter.
 * @param {Array} activeFilters - An array of active filter objects to apply.
 * @returns {Array} A filtered array of report posts.
 */
const filterResearch = (research, activeFilters) => research
  .filter(({
    communities = [],
    content: {
      rendered: content = '',
    } = {},
    date = '',
    'program-areas': programAreas = [],
    'report-types': reportTypes = [],
    title: {
      rendered: title = '',
    } = {},
    topics = [],
  }) => activeFilters.reduce((acc, { type, value }) => {
    // If this post is already marked as not matching, don't check further.
    if (! acc) {
      return acc;
    }

    // Fork for type of filter.
    switch (type) {
      case 'keyword':
        return title.toLowerCase().includes(value.toLowerCase())
          || content.toLowerCase().includes(value.toLowerCase());
      case 'communities':
        return communities.includes(parseInt(value, 10));
      case 'program-areas':
        return programAreas.includes(parseInt(value, 10));
      case 'report-types':
        return reportTypes.includes(parseInt(value, 10));
      case 'topics':
        return topics.includes(parseInt(value, 10));
      case 'years':
        return date.substring(0, 4) === value;
      default:
        break;
    }

    return acc;
  }, true));

export default filterResearch;
